module.exports = __webpack_public_path__ + "static/media/demo_higher_res.f78a9f59.png";